import { panaceaPublicClient } from './client';

export const createIngredientsToAvoidRequest = async (params: {
  cartUuid?: string;
  subscriptionUuid?: string;
  searchValue: string;
}): Promise<{ success: boolean }> => {
  const { data } = await panaceaPublicClient.post(
    '/v1/ecomm-platform/ingredients-to-avoid/requests',
    params,
  );
  return data;
};
